import React, { memo } from 'react';
import styled from 'styled-components';

import {
  colorWhite,
  mediaQueryDesktopMin,
  mediaQueryLaptopMin,
} from '@/styleUtils';

const Wrapper = styled(({ hideOnMobile, sticky, withoutBorder, ...props }) => (
  <section {...props} />
))`
  background-color: ${colorWhite};
  border-radius: 12px;
  width: 100%;
  padding: 16px;

  @media ${mediaQueryDesktopMin} {
    padding: 24px 16px;
  }

  ${({ hideOnMobile }) => {
    if (hideOnMobile) {
      return `
        display: none;

        @media ${mediaQueryLaptopMin} {
          display: block;
        }
      `;
    }

    return '';
  }}

  ${({ sticky }) => {
    if (sticky) {
      return `
        position: sticky;
        top: 16px;
      `;
    }

    return '';
  }}
`;

export default memo(Wrapper);
